import { render, staticRenderFns } from "./banksetNigeria.vue?vue&type=template&id=362a9b0e&scoped=true"
import script from "./banksetNigeria.vue?vue&type=script&lang=js"
export * from "./banksetNigeria.vue?vue&type=script&lang=js"
import style0 from "./banksetNigeria.vue?vue&type=style&index=0&id=362a9b0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a9b0e",
  null
  
)

export default component.exports